"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();

import type { StaticImageData } from "next/image";
import type React from "react";
import { Media } from "@/components/Media";
import { Link } from "@/i18n/routing";
import type { Case, Insight, Job, Setting } from "@/payload-types";
import { cn } from "@/utilities/ui";
import useClickableCard from "@/utilities/useClickableCard";

export type CardInsightData = Pick<
	Insight,
	| "slug"
	| "meta"
	| "title"
	| "tagsSolutions"
	| "tagsIndustries"
	| "tagsFramework"
> & { categoryCode?: string };
export type CardCaseData = Pick<
	Case,
	| "slug"
	| "meta"
	| "title"
	| "tagsSolutions"
	| "tagsIndustries"
	| "tagsFramework"
	| "clientLogo"
> & { testimonial?: any; categoryCode?: string };
export type CardJobData = Pick<
	Job,
	"slug" | "meta" | "title" | "categoryCode"
> & {
	tagsSolutions?: any;
	tagsIndustries?: any;
	tagsFramework?: any;
};

const renderTag = (tag: any) => {
	if (
		Array.isArray(tag) &&
		tag[0] &&
		typeof tag[0] === "object" &&
		"id" in tag[0] &&
		"title" in tag[0] &&
		"type" in tag[0]
	) {
		return (
			<span key={tag[0].id} className={`card_tag ${tag[0].type}`}>
				{tag[0].title}
			</span>
		);
	}
	return null;
};

export const Card: React.FC<{
	alignItems?: "center";
	className?: string;
	doc?: CardInsightData | CardCaseData | CardJobData;
	relationTo?: "insights" | "cases" | "jobs";
	title?: string;
	staticImage?: StaticImageData;
	view?: "grid" | "slider" | "archive" | undefined;
	categoryImages?: Setting;
}> = (props) => {
	const { card, link } = useClickableCard({});
	const {
		className,
		doc,
		relationTo,
		title: titleFromProps,
		staticImage,
		view,
		categoryImages,
	} = props;

	// Only access testimonial if relationTo is "cases"
	const clientLogo =
		relationTo === "cases" && "clientLogo" in (doc || {})
			? (doc as CardCaseData).clientLogo
			: undefined;

	const {
		slug,
		meta,
		title,
		tagsSolutions,
		tagsIndustries,
		tagsFramework,
		categoryCode,
	} = doc || {};
	const { description, image: metaImage } = meta || {};

	const titleToUse = titleFromProps || title;
	const sanitizedDescription = (description ?? "").replace(/\s/g, " ");
	const href = `/${relationTo}/${slug}`;
	const categoryImage = categoryImages?.jobCategoryImages?.find(
		(image) => image.category?.toLowerCase() === categoryCode,
	);
	const banner = metaImage || categoryImage?.image || undefined;

	const showMetaImage = () => {
		return !(relationTo === "cases" && (view === "grid" || view === "slider"));
	};

	if (relationTo === "jobs") {
		return (
			<Link href={href} className={cn("jobs", className)}>
				<article ref={card.ref}>
					{banner && (
						<Media
							className="card_image"
							resource={banner}
							src={staticImage}
							fill
						/>
					)}
					<div className="card_content">
						<h3>{titleToUse}</h3>
					</div>
				</article>
			</Link>
		);
	}

	return (
		<Link href={href} className={cn("", className)}>
			<article ref={card.ref}>
				<div className="card_media">
					{metaImage && showMetaImage() ? (
						<Media
							className="card_image"
							resource={metaImage}
							src={staticImage}
						/>
					) : (
						clientLogo &&
						view !== "archive" && (
							<Media
								className="card_image"
								resource={clientLogo}
								src={staticImage}
							/>
						)
					)}
				</div>
				<div className="card_content">
					<h3 className="">{titleToUse}</h3>
					{relationTo === "insights" && (
						<div className="insights-description">
							<h3 className="">{titleToUse}</h3>
							<p>{sanitizedDescription}</p>
						</div>
					)}
					{relationTo === "cases" && <p>{sanitizedDescription}</p>}
					{relationTo === "cases" && (
						<div className="card_tags">
							{renderTag(tagsFramework)}
							{renderTag(tagsIndustries)}
							{renderTag(tagsSolutions)}
							<Link
								href={href}
								className="more_tags"
								aria-label="View more tags"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									strokeWidth={1.5}
									stroke="white"
									aria-hidden="true"
								>
									<title>More tags</title>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M12 4.5v15m7.5-7.5h-15"
									/>
								</svg>
							</Link>
						</div>
					)}
				</div>
			</article>
		</Link>
	);
};
